import authService from '../api-authorization/AuthorizeService'
import * as XLSX from 'xlsx-js-style';

// Fixed leading columns (matching ReporteDespachoMultiproductoItem identity fields).
const FIXED_COLUMNS = [
    { key: 'fornitore', header: 'Fornitore', width: 28 },
    { key: 'puertoDescarga', header: 'Puerto de descarga', width: 20 },
    { key: 'numeroContenedor', header: 'Numero Contenedor', width: 20 },
    { key: 'marca', header: 'Marca', width: 32 },
    { key: 'tipoFruta', header: 'Tipo de fruta', width: 22 },
];

// Convert 0-based column index to Excel letters (A, B, ..., Z, AA, AB, ...).
function colLetter(index) {
    let n = index + 1;
    let s = '';
    while (n > 0) {
        const rem = (n - 1) % 26;
        s = String.fromCharCode(65 + rem) + s;
        n = Math.floor((n - 1) / 26);
    }
    return s;
}

export default class ReporteDespachoMultiproductoService {
    async ReporteDespacho(year, week, destinos) {
        const token = await authService.getAccessToken();
        const authHeaders = !token ? {} : { 'Authorization': `Bearer ${token}` };

        const queryString = `?year=${year}&week=${week}&destinos=${destinos}`;
        const reporteResponse = await fetch('api/ReporteDespacho/ExcelDataMultiproducto' + queryString, {
            headers: authHeaders,
        });
        const data = await reporteResponse.json();
        console.log("data", data);

        // data = { cajasPorPaleta: [int], items: [{ fornitore, puertoDescarga, numeroContenedor, marca, tipoFruta, cajasPorPaleta: { [n]: count } }] }
        const cajasPorPaleta = data.cajasPorPaleta || [];
        const items = data.items || [];

        // Build flat rows in the same column order used for headers.
        const rows = items.map(item => {
            const row = {};
            FIXED_COLUMNS.forEach(c => { row[c.key] = item[c.key] ?? ''; });
            cajasPorPaleta.forEach(n => {
                const v = item.cajasPorPaleta ? item.cajasPorPaleta[n] : 0;
                row['cpp_' + n] = (v === 0 || v == null) ? '' : v;
            });
            return row;
        });

        const semanaResponse = await fetch(`api/semanas?year=${year}&week=${week}`, { headers: authHeaders });
        const semanas = await semanaResponse.json();
        const semana = semanas.find(x => x.year == year && x.week == week);

        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows, { origin: 'A2', skipHeader: true });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Foglio1');

        const totalCols = FIXED_COLUMNS.length + cajasPorPaleta.length;
        const headerRow = [
            ...FIXED_COLUMNS.map(c => c.header),
            ...cajasPorPaleta.map(n => String(n)),
        ];
        XLSX.utils.sheet_add_aoa(worksheet, [headerRow], { origin: 'A1' });

        /* styles */
        const border = {
            top: { style: 'thin', color: { auto: 1 } },
            right: { style: 'thin', color: { auto: 1 } },
            bottom: { style: 'thin', color: { auto: 1 } },
            left: { style: 'thin', color: { auto: 1 } },
        };
        const baseHeaderFont = { name: 'Calibri', sz: 11, bold: true };
        const headerFixedStyle = {
            fill: { fgColor: { rgb: 'FFFF00' } }, // yellow
            alignment: { horizontal: 'center', vertical: 'center' },
            font: { ...baseHeaderFont, color: { rgb: '000000' } },
            border,
        };
        const headerDynamicStyle = {
            fill: { fgColor: { rgb: '000000' } }, // black
            alignment: { horizontal: 'center', vertical: 'center' },
            font: { ...baseHeaderFont, color: { rgb: 'FFFFFF' } },
            border,
        };
        const cellStyle = {
            alignment: { horizontal: 'center', vertical: 'center' },
            font: { name: 'Calibri', sz: 11 },
            border,
        };
        const cellStyleLeft = {
            alignment: { horizontal: 'left', vertical: 'center' },
            font: { name: 'Calibri', sz: 11, bold: true },
            border,
        };

        const lastDataRow = rows.length + 1; // header is row 1, data starts at row 2

        /* column widths */
        const wscols = FIXED_COLUMNS.map(c => ({ wch: c.width }));
        cajasPorPaleta.forEach(() => wscols.push({ wch: 6 }));
        worksheet['!cols'] = wscols;

        /* row heights */
        const wsrows = [{ hpx: 36.75 }];
        for (let i = 0; i < rows.length; i++) wsrows.push({ hpx: 17.5 });
        worksheet['!rows'] = wsrows;

        /* autofilter over the whole table */
        const lastColLetter = colLetter(totalCols - 1);
        worksheet['!autofilter'] = { ref: `A1:${lastColLetter}${lastDataRow}` };

        /* apply styles */
        for (let c = 0; c < totalCols; c++) {
            const letter = colLetter(c);
            const headerCell = letter + '1';
            if (worksheet[headerCell]) {
                worksheet[headerCell].s = c < FIXED_COLUMNS.length ? headerFixedStyle : headerDynamicStyle;
            }
            for (let r = 2; r <= lastDataRow; r++) {
                const cell = letter + r;
                if (!worksheet[cell]) continue;
                worksheet[cell].s = c < FIXED_COLUMNS.length ? cellStyleLeft : cellStyle;
                if (c >= FIXED_COLUMNS.length) {
                    worksheet[cell].z = '0;-0;;@';
                }
            }
        }

        const fileName = semana ? `ReporteDespacho_${semana.nombre}.xlsx` : 'ReporteDespacho.xlsx';
        XLSX.writeFile(workbook, fileName, { compression: true });
    }
}
